module.exports = __webpack_public_path__ + "img/首页未定栏目4.893e5f4d.jpg";